/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { authRoutes } from 'src/app/pages/auth-pages/auth-routing.module';

@Injectable()
export class UnauthorizedErrorInterceptor implements HttpInterceptor {
  private _isModalOpen = false;
  private _requests: HttpRequest<any>[] = [];
  private _authRoutesNames: string[];

  constructor(private router: Router) {
    this._authRoutesNames = this._getAuthRoutesNames;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(
      map((response) => {
        const responseT = response as HttpResponse<any>;
        return this.handleGraphQLError(responseT);
      }),
      catchError((error) => {
        return this.handleResponseError(error, request, next);
      }),
    );
  }

  private handleGraphQLError(response: any): HttpResponse<any> {
    const errors: any[] | undefined = response?.body?.errors;

    if (errors !== undefined && errors.length > 0) {
      const isUnauthorized = errors.find((x) => {
        return x?.extensions?.code === 'AUTH_NOT_AUTHENTICATED';
      });
      if (isUnauthorized) {
        throw isUnauthorized;
      }
    }
    return response;
  }

  private handleResponseError(
    error: any,
    request?: HttpRequest<any>,
    _next?: any,
  ) {
    if (
      error?.status === 401 ||
      error?.extensions?.code === 'AUTH_NOT_AUTHENTICATED'
    ) {
      if (!this._isModalOpen && !this._isAuthPage) {
        this._isModalOpen = true;
      }

      if (request) {
        this.collectRequest(request);
      }
    }

    return throwError(() => {
      return error;
    });
  }

  private collectRequest(request: HttpRequest<any>) {
    this._requests.push(request);
  }

  private sendRequests(next): void {
    for (const request of this._requests) {
      next.handle(request);
      continue;
    }
  }

  private get _isAuthPage(): boolean {
    const url = this.router.url.slice(1);
    return this._authRoutesNames.includes(url);
  }

  private get _getAuthRoutesNames(): string[] {
    return authRoutes.reduce<string[]>((arr, x) => {
      if (x.path) {
        arr.push(x.path);
      }
      return arr;
    }, []);
  }
}
